// test854
(854 && 0);
